<!-- =========================================================================================
  File Name: FormSidebar
  Description: For adding or edditing user information
  ----------------------------------------------------------------------------------------
  Item Name: JogjaBagus Backoffice
  Author: Hifi Saputra
  Author Email: hifisaputra1@gmail.com
  Author URL: https://github.com/fei77
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ formTitle }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new pb-6"
      :settings="settings"
    >
      <div class="p-6 vs-con-loading__container" id="form-sidebar">
        <select-status
          :data="formData.status"
          @change="formData.status = $event"
        />

        <select-member
          class="mt-3"
          label="Author"
          :data="formData.author"
          @change="formData.author = $event"
        />

        <select-marketing
          class="mt-3"
          :data="formData.saler"
          @change="formData.saler = $event"
        />

        <div class="flex flex-end">
          <vs-input
            label="Name"
            v-model="formData.name"
            class="mt-3 w-full mr-3"
          />
          <vs-input
            label="No. Contract"
            v-model="formData.contractNumber"
            class="mt-3 w-full"
          />
        </div>

        <vs-input label="Slug" v-model="computedSlug" class="mt-3 w-full" />

        <select-category
          :data="formData.category"
          :top-level="true"
          @change="formData.category = $event"
        />

        <select-category
          label="Subcategory"
          :data="formData.subcategory"
          :parentId="parentId"
          @change="formData.subcategory = $event"
        />

        <upload-image
          :src="formData.logoUrl"
          @upload-success="formData.logoUrl = $event"
          label="Logo"
        />

        <upload-image
          :src="formData.thumbnailUrl"
          @upload-success="formData.thumbnailUrl = $event"
          label="Thumbnail"
        />

        <vs-divider class="my-10"> Deal </vs-divider>

        <div class="flex flex-end">
          <date-input
            :data="formData.dateRegister"
            @change="formData.dateRegister = $event"
            class="mr-3"
          />

          <vs-input-number v-model="formData.priceRegister" />
        </div>

        <vs-divider class="my-10"> Renewal </vs-divider>

        <div class="flex flex-end">
          <date-input
            :data="formData.dateRenewal"
            @change="formData.dateRenewal = $event"
            class="mr-3"
          />

          <vs-input-number v-model="formData.priceRenewal" />
        </div>

        <select-billing-cycle
          class="mt-5"
          :data="formData.billingCycle"
          @change="formData.billingCycle = $event"
        />
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submit">Save</vs-button>
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
const slugify = require("slugify");
export default {
  props: {
    itemId: {
      type: String,
      default: null,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    formTitle: {
      type: String,
      required: true,
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      loading: false,
      data: {},
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    validate() {
      return this.formData.name.length > 0;
    },
    parentId() {
      if (this.formData.category && this.formData.category.id) {
        return this.formData.category.id;
      } else {
        return "";
      }
    },
    computedSlug: {
      get() {
        return (
          this.formData.slug ||
          slugify(this.formData.name || "", { lower: true })
        );
      },
      set(val) {
        this.formData.slug = slugify(val, { lower: true });
      },
    },
  },
  methods: {
    submit() {
      if (!this.validate) return false;
      if (this.itemId) {
        this.updateItem();
      } else {
        this.createItem();
      }
    },
    updateItem() {
      console.log(this.formData)
      this.$vs.loading();

      this.$store
        .dispatch("businessDoc/setData", { ...this.formData, slug: this.computedSlug, id: this.itemId })
        .then(() => {
          this.notifySuccess("Data updated");
          this.closeSidebar();
        })
        .catch((err) => {
          this.notifySuccess(err.message);
        })
        .then(() => this.$vs.loading.close());
    },
    createItem() {
      this.$vs.loading();

      this.$store
        .dispatch("businessDoc/insertData", { ...this.formData, slug: this.computedSlug })
        .then((data) => {
          this.notifySuccess("Data created");
          this.closeSidebar();
          this.$emit(createdListing, data);
        })
        .catch((err) => {
          this.notifySuccess(err.message);
        })
        .then(() => this.$vs.loading.close());
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
